module.exports = __webpack_public_path__ + "static/img/mobilesquare-01.fe6a02e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilesquare-01.png
// module id = VkWU
// module chunks = 1